import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
var LinkList = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment linkList on ComponentPresentationLinkList {\n    href\n    value\n    alt\n  }\n"])));
export default LinkList;